import { styled } from "lib/theme";

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  background-color: ${({ theme }) => theme.app.colors.pageBackground};

  & > * {
    color: ${({ theme }) => theme.app.colors.secondaryText};
    text-align: center;
    font-family: ${({ theme }) => theme.app.fontFamily} !important;
  }

  & > h1 {
    font-size: 42px;
    line-height: 50px;
    font-weight: 600;
  }

  & > p {
    font-size: 24px;
    line-height: 40px;
    font-weight: 400;
    max-width: 800px;
  }
`;

export function ProjectError({
  title,
  message,
}: {
  title: string;
  message: string;
}) {
  return (
    <Wrapper>
      <h1 className="text-center text-3xl font-bold">{title}</h1>
      <p className="mt-4 text-center text-lg">{message}</p>
    </Wrapper>
  );
}
